var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31689 19.7742V11.0911H8.92315L9.31055 7.69143H6.31689V5.52597C6.31689 4.54494 6.56008 3.87326 7.81278 3.87326H9.4001V0.842246C8.62778 0.749219 7.85147 0.704301 7.07473 0.707699C4.77105 0.707699 3.18939 2.28836 3.18939 5.19013V7.68508H0.600098V11.0848H3.19504V19.7742H6.31689Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.d0cf1284dcf79c3da6e09200cc0cae75.svg";
export { ForwardRef as ReactComponent };